import type { LinkProps } from '@ab-core/link';
import type { FavoriteItemType } from './types';
import { useGetFavoriteList } from './utils';

type CommercialFavoriteItemType = FavoriteItemType & { urlTarget?: LinkProps['target'] };

type ReturnType = {
    favoriteList: Array<FavoriteItemType>;
    commercialFavoriteList: Array<CommercialFavoriteItemType>;
};

export const useGetFavoriteItems = (): ReturnType => {
    const favoriteList = useGetFavoriteList();
    const commercialFavoriteList: Array<CommercialFavoriteItemType> = [];

    return {
        favoriteList,
        commercialFavoriteList
    };
};
